import { gql } from '@apollo/client';
import { STAFF_FIELDS } from '../staff';
import { ASSESSMENT_FIELDS } from './assessment.fields';

export const ASSESSMENT_DETAIL_FIELDS = gql`
  ${ASSESSMENT_FIELDS}
  ${STAFF_FIELDS}
  fragment AssessmentDetailFields on Assessment {
    ...AssessmentFields
    approver {
      ...StaffFields
    }
    staff {
      ...StaffFields
    }
    managerAssessment {
      ...AssessmentFields
    }
  }
`;
